import React from 'react'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS, VB_FEATURED_CATEGORIES } from '../../CustomElements/elementTypes'
import CategoryProductList from '../../Core/ListComponents/CategoryProductList'
import StandardCategoryBanner from '../../Core/Banners/StandardCategoryBanner'
import { FeatureCategoriesCarousel } from '../../Core/Carousels/FeatureCategoriesCarousel'
import { useIntl } from '@jetshop/intl'
import { parseCategoryKeywordFlags } from './parseCategoryKeywordFlags'

const CategoryStandard = ({ category, parents }) => {
   const t = useIntl()

   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)
   const featuredCategoryItems = category?.data?.items?.find(c => c?.type == VB_FEATURED_CATEGORIES)?.children ?? [];
   const featuredCategoriesTitle = t('popular_categories') || 'Populära kategorier'

   const keywordFlags = parseCategoryKeywordFlags(category?.head?.metaTags ?? [])

   return (
      <React.Fragment>
         <StandardCategoryBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
         />

         <FeatureCategoriesCarousel 
            categories={featuredCategoryItems} 
            title={featuredCategoriesTitle}
         />

         {keywordFlags.RenderComponentsAbove && (
            <RenderCustomElements items={items} />
         )}

         {!keywordFlags.HideProductFlow && (
            <CategoryProductList category={category}></CategoryProductList>
         )}

         {keywordFlags.RenderComponentsBelow && (
            <RenderCustomElements items={items} />
         )}
      </React.Fragment>
   )
}

export default CategoryStandard
